import { AnimatedLogo, AnimatedSlogan } from '@plcy-io/app-core';
import React from 'react';

import styles from './ComingSoonPage.module.css';
import { useWaitlistSignup } from './marketing/useWaitlistSignup.ts';
import { SLOGAN_KEYWORDS } from './slogan-keywords.js';

function EmailCapture(): React.ReactElement {
  const { email, setEmail, status, errorMessage, submit } =
    useWaitlistSignup('coming-soon');

  function handleSubmit(e: React.FormEvent<HTMLFormElement>): void {
    e.preventDefault();
    void submit();
  }

  if (status === 'success') {
    return (
      <div className={styles['emailWrapper']}>
        <p className={styles['emailSuccess']}>You&apos;re on the list.</p>
      </div>
    );
  }

  return (
    <div className={styles['emailWrapper']}>
      <form className={styles['emailForm']} onSubmit={handleSubmit}>
        <input
          className={styles['emailInput']}
          type='email'
          placeholder='Enter your email'
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          disabled={status === 'loading'}
          required
          aria-label='Email address'
          data-lpignore='true'
          data-1p-ignore
        />
        <button
          className={styles['emailButton']}
          type='submit'
          disabled={status === 'loading'}
        >
          {status === 'loading' ? '...' : 'Notify Me'}
        </button>
      </form>
      {status === 'error' && (
        <p className={styles['emailError']}>{errorMessage}</p>
      )}
    </div>
  );
}

export function ComingSoonPage(): React.ReactElement {
  return (
    <main className={styles['root']} aria-label='Plcy.io coming soon'>
      <div className={styles['backgroundBase']} aria-hidden='true' />
      <div className={styles['orbBlue']} aria-hidden='true' />
      <div className={styles['orbPurple']} aria-hidden='true' />
      {/* <CornerRibbon text='Coming Soon' delay={2500} /> */}
      <div className={styles['stage']}>
        <AnimatedLogo
          variant='dark'
          animation='entrance'
          height={170}
          shockwaveMode='fullpage'
        />
        <AnimatedSlogan
          text={'It\u2019s time for something...'}
          accentText='different.'
          variant='dark'
          animation='entrance'
          delay={2200}
          fontSize='clamp(1.375rem, 4vw, 2.25rem)'
          fontWeight={300}
          accentFontWeight={400}
          rotation={{
            keywords: SLOGAN_KEYWORDS,
            displayDuration: 3500,
            transitionDuration: 450,
            initialPause: 2500,
          }}
        />
      </div>
      <footer className={styles['footer']}>
        <div className={styles['footerContent']}>
          <EmailCapture />
          <div className={styles['footerLinks']}>
            <a href='/why' className={styles['blogLink']}>
              why plcy.io
            </a>
            <a
              href='https://blog.plcy.io'
              className={styles['blogLink']}
              target='_blank'
              rel='noopener noreferrer'
            >
              blog
            </a>
          </div>
        </div>
      </footer>
    </main>
  );
}
